import React from 'react';
import styled from 'styled-components';

type Props = {
    title?: any;
    children?: React.ReactNode;
};


const Card = (props: Props) => {
    const { title, children } = props;

    return (
        <CardWithStyled>
            <h2 className='mainContents__container__title'>
                {title}
            </h2>
            <ContentsWithStyled className=''>
                {children}
            </ContentsWithStyled>
        </CardWithStyled>
    );
};
const CardWithStyled = styled.div`
    background-color: #fff;
    border-radius: 5px;
    min-width: 250px;
    min-height: 260px;
    box-shadow: 1px 1px 6px #ddd;
    margin: 0 5px 30px;
    padding: 20px;
`
const ContentsWithStyled = styled.div`
` 

export default Card;